import React from 'react'
import styles from './Suggestion.module.scss'
import { handleClickRecent } from '@/helpers/props'
import Icon from '@/components/UI/icon/Icon'
import Box from '@/components/UI/box/Box'
import Typography from '@/components/UI/typography/Typography'
const Suggestion = ({
  isPhrase,
  setSearchTxt,
  closeHandler,
  handleClickCity,
}) => {
  const recentSearches =
    typeof window !== 'undefined' ? localStorage.getItem('recent-searches') : ''
  const recentArr = recentSearches ? JSON.parse(recentSearches) : null
  return (
    <>
      {recentArr && recentArr.length !== 0 && (
        <Box className="top-main-search">
          <Typography variant={'bodyL'}>جستجوهای اخیر شما</Typography>
          <ul className={styles['latest-searches']}>
            {recentArr.reverse().map((item, index) => {
              return (
                <React.Fragment key={`recent-search-item-${index}`}>
                  <li
                    onClick={() => {
                      isPhrase.current = false
                      setSearchTxt(item.name)
                      closeHandler()
                      handleClickRecent(item.name, item.type, {
                        ...item,
                      })
                    }}
                    className={styles['suggestion-item']}
                  >
                    <Box className={styles['icon-container']}>
                      <Icon name="refresh" type="primary" />
                    </Box>
                    <Box>
                      <Typography variant={'bodyM'}>{item.name}</Typography>
                    </Box>
                  </li>
                </React.Fragment>
              )
            })}
          </ul>
        </Box>
      )}
      <Box className="bottom-main-search">
        <Typography variant={'bodyL'}>شهرهای پرطرفدار</Typography>
        <Box className="bottom-main-search-list">
          <Box
            onClick={() => handleClickCity('تهران')}
            className={styles['suggestion-item']}
          >
            <Box className={styles['icon-container']}>
              <Icon name="location" type="primary" />
            </Box>
            <Typography variant={'bodyL'}>تهران</Typography>
          </Box>
          <Box
            onClick={() => handleClickCity('کردان')}
            className={styles['suggestion-item']}
          >
            <Box className={styles['icon-container']}>
              <Icon name="location" type="primary" />
            </Box>
            <Typography variant={'bodyL'}>کردان</Typography>
          </Box>
          <Box
            onClick={() => handleClickCity('رامسر')}
            className={styles['suggestion-item']}
          >
            <Box className={styles['icon-container']}>
              <Icon name="location" type="primary" />
            </Box>
            <Typography variant={'bodyL'}>رامسر</Typography>
          </Box>
          <Box
            onClick={() => handleClickCity('رشت')}
            className={styles['suggestion-item']}
          >
            <Box className={styles['icon-container']}>
              <Icon name="location" type="primary" />
            </Box>
            <Typography variant={'bodyL'}>رشت</Typography>
          </Box>
          <Box
            onClick={() => handleClickCity('مشهد')}
            className={styles['suggestion-item']}
          >
            <Box className={styles['icon-container']}>
              <Icon name="location" type="primary" />
            </Box>
            <Typography variant={'bodyL'}>مشهد</Typography>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Suggestion
